var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E5FCE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.752 16.9973H32.253",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0022 18.2481V15.7471",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0017 20.9984C28.7917 20.9984 27 19.2067 27 16.9968C27 14.7869 28.7917 12.9951 31.0017 12.9951C33.2116 12.9951 35.0033 14.7869 35.0033 16.9968C35.0033 19.2067 33.2116 20.9984 31.0017 20.9984",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4993 21.0244C24.7268 21.0244 25.7222 22.0198 25.7222 23.2473C25.7222 24.4749 24.7268 25.4703 23.4993 25.4703C22.2718 25.4703 21.2764 24.4749 21.2764 23.2473C21.2764 22.0198 22.2718 21.0244 23.4993 21.0244",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5014 29.0279C27.3853 28.7348 27.2043 28.4727 26.9732 28.2586V28.2586C26.582 27.8964 26.0718 27.6943 25.5386 27.6943C24.6492 27.6943 22.3512 27.6943 21.4619 27.6943C20.9286 27.6943 20.4174 27.8964 20.0263 28.2586V28.2586C19.7952 28.4727 19.6151 28.7358 19.498 29.0279",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0061 16.7624C25.9357 16.2762 24.7512 15.9971 23.4987 15.9971C18.8027 15.9971 14.9951 19.8047 14.9951 24.5006C14.9951 29.1966 18.8027 33.0042 23.4987 33.0042C28.1946 33.0042 32.0022 29.1966 32.0022 24.5006C32.0022 23.2481 31.7231 22.0636 31.2369 20.9932",
    stroke: "#4CAF50",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.47d7acd2814ce1a8be20419d42aa6a50.svg";
export { ForwardRef as ReactComponent };